/*
 * Blueprint and resource card click handling.
 * Ported from c2Archive/blueprints.js (handleCardClicks, renumberParallelItems).
 */
(function (__module__, c2, $) {
  'use strict';

  // Parse the candidate URL against the current origin and only navigate if
  // (a) parsing succeeds and (b) the resolved protocol is http(s). This
  // blocks `javascript:` / `data:` / etc. from a stray href attribute
  // reaching window.location. Using the standard URL() constructor rather
  // than a regex allow-list is also more legible to static analysers.
  function safeNavigationUrl(url) {
    if (!url || typeof url !== 'string') return null;
    var parsed;
    try {
      parsed = new URL(url, window.location.origin);
    } catch (e) {
      return null;
    }
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return null;
    return parsed.href;
  }

  function followBlueprintLink($card, e, newTab) {
    var url = $card.data('href');

    // Add group and environment filter values to the URL if present.
    var groupId = $('[name=filter_by_group]').val();
    var envId = $('[name=filter_by_env]').val();
    if (groupId || envId) {
      url += '?';
      url += groupId ? 'group=' + groupId + '&' : '';
      url += envId ? 'env=' + envId : '';
    }

    // Manage-link clicks target the child span; follow that href instead.
    var $manageLink = $(e.target).parent('a.manage-link');
    if ($manageLink.length) {
      url = $manageLink.attr('href');
    }

    if ($card.hasClass('orderable') || $manageLink.length) {
      var safeUrl = safeNavigationUrl(url);
      if (!safeUrl) return;
      if (newTab) {
        window.open(safeUrl, '_blank');
      } else {
        window.location.href = safeUrl;
      }
    }
  }

  /*
   * Attach click/middle-click handlers to blueprint and resource cards inside
   * $container.  Idempotent — safe to call multiple times.
   */
  function handleCardClicks($container) {
    $container.off('mousedown', '.blueprint-card, .resource-card');
    $container.off('click', '.blueprint-card, .resource-card');

    // Middle-click opens in new tab (mousedown fires during drag too).
    $container.on('mousedown', '.blueprint-card, .resource-card', function(e) {
      if (e.which === 2) {
        e.preventDefault();
        followBlueprintLink($(this), e, true);
      }
    });

    // Left-click; Cmd/Ctrl-click opens in new tab.
    $container.on('click', '.blueprint-card, .resource-card', function(e) {
      e.preventDefault();
      followBlueprintLink($(this), e, e.metaKey || e.ctrlKey);
    });
  }

  /*
   * Renumber sequence labels on teardown/parallel service-item panels so that
   * panels marked "execute in parallel" share the same sequence number as
   * their predecessor.
   */
  function renumberParallelItems($serviceItemList) {
    var $panels = $serviceItemList.find('.item-details');
    $panels.each(function() {
      var $panel = $(this);
      var $nextPanel = $panel.closest('li').next().find('.item-details');
      if ($nextPanel.length) {
        var seq = parseInt($panel.find('.sort-seq').text(), 10);
        var $nextSeq = $nextPanel.find('.sort-seq');
        if (!$nextSeq.length) { return; }
        var isParallel = $panel.find('input[name=execute_in_parallel]').prop('checked');
        $nextSeq.text(isParallel ? seq : seq + 1);
      }
    });
  }

  c2[__module__] = {
    handleCardClicks: handleCardClicks,
    renumberParallelItems: renumberParallelItems,
  };

})('blueprints', window.c2, window.jQuery);
